import React from 'react'
import moment from 'moment'
import img from '../../../../public/static/image-background/logo-v-02.png'
import locales from '../../../../public/static/locales/vi.json'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

const Mau4 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100
    const color = {
        first: '#ff4b1f',
        second: '#ff9068',
        text: '#ffffff',
        bg: '#110502'
    }
    const classCustom = size < 1000 ? 'view' : 'export'

    return (
        <div id={id} className={`bg-match-mau4`} style={{ width: width, minHeight: width / 1.3, padding: `${1.6 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', backgroundColor: color.bg }}>
            <div style={{ width: `100%`, minHeight: `calc(${width / 1.3}px - ${3.2 * px}px)`, padding: `${px * 1.5}px ${px * 1.5}px ${px * 4.2}px ${px * 1.5}px`, position: 'relative', background: 'radial-gradient(circle at center, #631206 0%, #110502 80%)', borderRadius: `${px * 2}px`, overflow: 'hidden' }}>

                {/* Header */}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', borderBottom: `2px solid rgba(255,75,31,0.3)`, paddingBottom: `${px * 2}px` }}>
                    <div style={{ flex: 1 }}>
                        <Image src={dataSeason?.logo} style={{ width: `${px * 9}px`, objectFit: 'contain' }} />
                    </div>
                    <div style={{ flex: 6, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <h1 style={{ textAlign: 'center', color: color.second, fontSize: `${2.8 * px}px`, textTransform: 'uppercase', letterSpacing: `${px * 0.2}px`, textShadow: '0 0 10px rgba(255,75,31,0.5)' }}>{dataSeason?.name}</h1>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <Image src={img} style={{ width: `${px * 9}px`, objectFit: 'contain' }} />
                    </div>
                </div>

                {/* Title */}
                <div style={{ marginTop: `${px * 3}px`, marginBottom: `${px * 3}px` }}>
                    <h1 style={{ textAlign: 'center', color: color.text, fontSize: `${4.5 * px}px`, textTransform: 'uppercase', fontWeight: 'bold', textShadow: '0 4px 10px rgba(0,0,0,0.5)' }}>{t(titleTemplate(dataSchedules[0]?.dataGo))}</h1>
                    <h2 style={{ textTransform: 'uppercase', margin: `${px}px auto 0`, width: 'max-content', color: '#fff', backgroundColor: color.first, padding: `${px}px ${6 * px}px`, borderRadius: `${2 * px}px`, fontSize: `${2.8 * px}px`, fontWeight: 'bold' }}>{t(numberRound)}</h2>
                </div>

                {/* Matches Grid */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: `${px * 2}px`, marginTop: `${px * 4}px`, padding: `0 ${px * 2}px` }}>
                    {dataSchedules[0]?.dataGo
                        ?.filter(i => i.awayTeam.name !== 'hidden' && i.homeTeam.name !== 'hidden')
                        ?.map((i, idx) => (
                            <Item key={`${idx}${new Date()}`} data={i} px={px} classCustom={classCustom} idx={idx} width={width} />
                        ))}
                </div>

                {/* Sponsors */}
                {isShowSponsor && sponsorData?.length > 0 && (
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: `${6 * px}px`, padding: `${2 * px}px`, background: '#fff', borderRadius: `${3 * px}px`, flexWrap: 'wrap', border: `3px solid ${color.first}` }}>
                        {sponsorData?.slice(0, 10)?.map((i, idx) => <Image key={idx} src={i.logo || config.logo} style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain', margin: `0 ${px}px` }} />)}
                    </div>
                )}

                {/* Footer */}
                <p style={{ textAlign: 'center', color: color.second, fontSize: `${2 * px}px`, position: 'absolute', bottom: `${px}px`, right: `${1.5 * px}px`, fontWeight: 'bold' }}>{window.sessionStorage.getItem('HomeUrl') || 'VSPORTS.VN'}</p>
            </div>
        </div>
    )
}

const Item = React.memo(
    ({ data, px, classCustom, idx, width }) => {
        const { t } = useTranslation()
        const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
        let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
        let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''

        const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']

        let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
        let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name

        let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
        let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

        return (
            <div style={{ width: `100%`, background: 'rgba(0,0,0,0.5)', border: '2px solid #ff4b1f', borderRadius: `${3 * px}px`, padding: `${1.5 * px}px ${3 * px}px`, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 8px 32px 0 rgba(255,75,31,0.2)' }}>

                {/* Home Team */}
                <div style={{ flex: 2, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <Image src={data?.homeTeam?.logo} style={{ width: `${px * 7}px`, height: `${px * 7}px`, borderRadius: '50%', objectFit: 'cover', border: `3px solid #ff9068`, padding: `${px * 0.3}px`, backgroundColor: '#fff' }} />
                    <Name propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={homeName} px={px} isLeft={true} />
                </div>

                {/* Time/Score */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <h2 style={{ color: '#fff', textAlign: 'center', fontSize: `${1.6 * px}px`, textTransform: 'uppercase', fontWeight: 'bold' }}>
                        {t('semifinal')} {idx + 1}
                    </h2>
                    <div style={{ color: '#ff9068', fontSize: `${1.8 * px}px`, textTransform: 'uppercase', textAlign: 'center', marginBottom: `${px * 0.5}px`, fontWeight: 'bold' }}>
                        {data?.stadium ? `${data?.stadium} • ` : ''}{formatDateTime(data?.dateTime, 'dateTime')}
                    </div>
                    {data?.isCompleted ? (
                        <div style={{ background: '#110502', padding: `${px * 0.5}px ${px * 2}px`, borderRadius: `${px}px`, border: '1px solid #ff4b1f', minWidth: `${px * 16}px` }}>
                            <div style={{ color: '#ff4b1f', fontSize: `${4 * px}px`, letterSpacing: '4px', textAlign: 'center', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                                {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                                {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                                {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                                {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
                            </div>
                        </div>
                    ) : (
                        <div style={{ background: '#110502', padding: `${px * 0.5}px ${px * 2}px`, borderRadius: `${px}px`, border: '1px solid #ff4b1f' }}>
                            <div style={{ color: '#ff4b1f', fontSize: `${3 * px}px`, letterSpacing: '2px', textAlign: 'center', fontWeight: 'bold' }}>
                                {formatDateTime(data?.dateTime, 'time')}
                            </div>
                        </div>
                    )}
                    {data?.isCompleted && data?.hasPenalty && (
                        <div style={{ color: '#fc0366', fontSize: `${1.5 * px}px`, marginTop: `${px * 0.5}px`, fontWeight: 'bold' }}>
                            (PK: {data?.homeTeam?.penaltyScore} - {data?.awayTeam?.penaltyScore})
                        </div>
                    )}
                </div>

                {/* Away Team */}
                <div style={{ flex: 2, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <Name propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={awayName} px={px} isLeft={false} />
                    <Image src={data?.awayTeam?.logo} style={{ width: `${px * 7}px`, height: `${px * 7}px`, borderRadius: '50%', objectFit: 'cover', border: `3px solid #ff9068`, padding: `${px * 0.3}px`, backgroundColor: '#fff' }} />
                </div>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data)
)

const Name = React.memo(
    ({ name, px, propClass, isLeft }) => {
        const reSizeBasedOnWidth = () => {
            let fontSize = window && window?.getComputedStyle(document.querySelector(`.${propClass}`))?.fontSize
            if (fontSize) {
                document.querySelector(`.${propClass}`).style.fontSize = parseFloat(fontSize) - 0.3 * px + 'px'
                if (document.querySelector(`.${propClass}`).scrollHeight > document.querySelector(`.contain${propClass}`).clientHeight) {
                    reSizeBasedOnWidth()
                }
            }
        }
        const processInput = () => {
            if (document.querySelector(`.${propClass}`)) {
                document.querySelector(`.${propClass}`).innerHTML = name
                document.querySelector(`.${propClass}`).style.fontSize = px * 2.8 + 'px' // Default font size
                reSizeBasedOnWidth()
            }
        }

        React.useEffect(() => {
            processInput()
        }, [name])

        return (
            <div className={`contain${propClass}`} style={{ width: '100%', height: `${7 * px}px`, display: 'flex', alignItems: 'center', justifyContent: isLeft ? 'flex-start' : 'flex-end', overflow: 'hidden', padding: `0 ${px * 1.5}px` }}>
                <h2 className={propClass} style={{ color: '#ffffff', textAlign: isLeft ? 'left' : 'right', textTransform: 'uppercase', margin: 0, fontWeight: 'bold', wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 1.2 }}></h2>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name)
)

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props.src) {
            getBase64(props.src).then(r => setData(r))
        }
    }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) && JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) && JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau4, areEqual)
